import { useEffect } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import auth from 'auth'
import { OAUTH_IFRAME_MESSAGE_TYPE } from 'libs/oauthIframeBridge'

export default function useOAuthIframeCompletionListener(referer = '/') {
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) {
        return
      }

      if (event.data?.type !== OAUTH_IFRAME_MESSAGE_TYPE) {
        return
      }

      if (!event.data?.token) {
        return
      }

      auth.setToken(event.data.token)

      history.replace({
        pathname: event.data.pathname || referer || '/',
        search: event.data.search ?? location.search,
        state: event.data.state,
      })
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [history, referer, location.search])
}



// WEBPACK FOOTER //
// ./src/hooks/useOAuthIframeCompletionListener/index.ts